var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPLOAD_WEIGHT_DISCREPANCY_REQUEST, uploadWeightDiscrepancySuccess, uploadWeightDiscrepancyFailure, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const uploadWeightDiscrepancyFile = (action) => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append("file", action.payload);
    try {
        const response = yield APIIN.formUpload("/report/admin/upload/weight-mismatch", { file: action.payload });
        return response;
    }
    catch (error) {
        throw error;
    }
});
function* uploadWeightDiscrepancyFileWorker(action) {
    var _a;
    try {
        const response = yield call(uploadWeightDiscrepancyFile, action);
        if (response === null || response === void 0 ? void 0 : response.success) {
            // ✅ success with filePath
            yield put(uploadWeightDiscrepancySuccess(response));
        }
        else {
            // ⚠️ server responded but success = false
            yield put(uploadWeightDiscrepancyFailure(response));
        }
    }
    catch (error) {
        if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) {
            // ✅ handle backend error with filePath included
            yield put(uploadWeightDiscrepancyFailure(error.response.data));
        }
        else {
            // generic error
            yield put(uploadWeightDiscrepancyFailure({ success: false, filePath: null, message: "An error occurred while uploading the file" }));
        }
    }
}
export function* watchUploadWeightDiscrepancyFile() {
    yield takeLatest(UPLOAD_WEIGHT_DISCREPANCY_REQUEST, uploadWeightDiscrepancyFileWorker);
}
